/**
 * 范围框在中间
 * Y轴 - %
 * 浮窗 - 心率集中在X次/分
 */
export default function getEchartsOptionBarB2(xAxis_data, series_data, markArea_range) {
	let barWidth = 810 / xAxis_data.length - 5 > 10 ? 10 : undefined

	// 区间范围计算
	let xWidth = (810 - 25);
	let singleBarAreaWidth = xWidth / xAxis_data.length;
	let x1;
	let x2;
	if (xAxis_data.indexOf(markArea_range[0]) != -1) {
		x1 = xAxis_data.indexOf(markArea_range[0]) * singleBarAreaWidth + 45.0;
	}
	if (xAxis_data.indexOf(markArea_range[1]) != -1) {
		x2 = (xAxis_data.indexOf(markArea_range[1]) + 1) * singleBarAreaWidth + 45.0;
	}
	let markArea_data;
	if (x1 || x2) {
		markArea_data = markArea_range.length == 2 ? [
			[
				{ xAxis: markArea_range[0], x: x1 },
				{ xAxis: markArea_range[1], x: x2 },
			]
		] : undefined;
	} else {
		markArea_data = markArea_range.length == 2 ? [
			[
				{ xAxis: markArea_range[0] },
				{ xAxis: markArea_range[1] },
			]
		] : undefined;
	}

	let option = {
		grid: {
			x: 15,
			y: 15,
			x2: 15,
			y2: 10,
			containLabel: true
		},
		tooltip: {
			trigger: "axis",
			backgroundColor: 'rgba(255, 255, 255, 0.95)',
			borderColor: "#D8E2F8",
			borderWidth: 1,
			borderRadius: 4,
			textStyle: {
				color: "#8394B9",
				fontSize: 14
			},
			confine: true,
			formatter: function (val) {
				let blankDot = "<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF00'></span>";
				let xName = val[0].name.toString();
				let value = val[0].value;
				let res = Math.floor(value * 100);
				return val[0].marker + res + '%心率' + '<br/>' + blankDot + '集中在' + xName + '次/分';
			}
		},
		dataZoom: {
			type: 'inside',
			zoomLock: true
		},
		xAxis: {
			type: 'category',
			data: xAxis_data,
			axisTick: { // 坐标轴刻度相关设置。
				show: false
			},
			axisLine: { // 坐标轴轴线相关设置。
				lineStyle: {
					color: "rgba(144, 148, 166, 0.1)",
					type: "solid",
				},
			},
			axisLabel: { // 坐标轴刻度标签的相关设置。
				show: true,
				textStyle: {
					color: "#A5A9BC", //坐标的字体颜色
					fontSize: 10
				},
				formatter: function (val, index) {
					return val;
				},
				// interval: 5 // 强制设置坐标轴分割间隔。
			},
		},
		yAxis: { // y 轴配置项
			axisTick: { // 坐标轴刻度相关设置。
				show: false
			},
			axisLine: { // 坐标轴轴线相关设置。
				show: false
			},
			axisLabel: { // 坐标轴刻度标签的相关设置。
				formatter: function (val) {
					return Math.floor(val * 100) + '%';
				},
				textStyle: {
					color: "#A5A9BC", //坐标的字体颜色
					fontSize: 10
				}
			},
		},
		series: [
			{
				type: 'bar',
				data: series_data,
				itemStyle: {
					normal: {
						barBorderRadius: [2, 2, 0, 0],
						color: '#A970FF'
					},
				},
				markArea: {
					itemStyle: {
						color: '#4C52E410',
						lineStyle: {
							type: "dashed",
							color: "#8287F4",
						},
						borderColor: "#8287F4",
						borderWidth: 1,
						borderType: 'dashed',
					},
					data: markArea_data,
				},
				barWidth: barWidth
			}
		]
	}
	return option;
}